import React from 'react'

import './AppLoader.scss'

const AppLoader = () => {
  return <div className="AppLoader"></div>
}

export default AppLoader
